import { type SWRKey, useSWRImmutable } from 'services/swr';
import { useCSRFHeader } from 'services/api/UserData';

export interface Incident {
    id: string;
    name: string;
    status: string;
    shortlink?: string;
}

export interface IncidentStatusPage {
    id: string;
    name: string;
    time_zone?: string;
    updated_at?: string;
    url?: string;
}

export interface IncidentsResponse {
    page?: IncidentStatusPage;
    incidents: Incident[];
}

export const useIncidents = () => {
    const { data: csrfData } = useCSRFHeader({ shouldRetryOnError: false });
    const key: SWRKey = csrfData?.token
        ? {
              url: '/api/utils/incidents',
              baseURL: process.env.GATSBY_SITE_URL,
              headers: { 'X-Csrf': csrfData.token },
          }
        : null;

    return useSWRImmutable<IncidentsResponse>(key, { shouldRetryOnError: false });
};
